export default function () {
    return {
        contenttree: {},
        expanded_branches: {},
    };
}
